module.exports = __webpack_public_path__ + "static/media/une.f32f7cac.png";